var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { useState } from 'react';

import { connect } from 'react-redux';

import { TableRow } from "../Library/components/TableRow";








const mapStateToProps = (state, props) => ({
  documents: state[props.storeKey].documents,
  selectionLength: state[props.storeKey].ui.get('selectedDocuments').size
});

const connector = connect(mapStateToProps);


const TableRowsComponent = ({
  documents,
  columns,
  clickOnDocument,
  storeKey,
  selectionLength
}) => {
  const [multipleSelection, setMultipleSelection] = useState(selectionLength > 1);
  return /*#__PURE__*/(
    React.createElement(React.Fragment, null,
    documents.get('rows').map((entity) => /*#__PURE__*/
    _jsx(TableRow, {
      entity: entity,
      columns: columns,
      clickOnDocument: clickOnDocument,
      storeKey: storeKey,

      setMultipleSelection: setMultipleSelection,
      multipleSelection: multipleSelection }, entity.get('_id')
    )
    )
    ));

};

export const TableRows = connect(mapStateToProps)(TableRowsComponent);